import { render, staticRenderFns } from "./tabOptions.vue?vue&type=template&id=22058971"
import script from "./tabOptions.vue?vue&type=script&lang=js"
export * from "./tabOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports